<template>
  <div :class="['editors-staff-breadcrumbs-skeleton', { _mobile: isMobile }]"></div>
</template>

<script setup lang="ts">
const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editors-staff-breadcrumbs-skeleton {
  .skeleton(168px, 18px);
}
</style>
